import { loadable } from '../../../common/utils/lazyLoading';

const ProgramIntake = loadable(() => import('../ProgramIntake'));
const StaffLearningSpace = loadable(() => import('../StaffLearningSpace'));
const StudentLearningSpace = loadable(() => import('../StudentLearningSpace'));
const Timetable = loadable(() => import('../Timetable'));

export default [
  {
    id: 'program_intake',
    title: 'Program Intake',
    route: 'program-intake',
    component: ProgramIntake,
    icon: 'ed-program-intake',
    permission: 'program_intake',
  },
  {
    id: 'staff_learning_space',
    title: 'Staff Learning Space',
    route: 'staff-learning-space',
    component: StaffLearningSpace,
    icon: 'ed-staff-learning-space',
    permission: 'staff_learning_space',
  },
  {
    id: 'student_learning_space',
    title: 'Student Learning Space',
    route: 'student-learning-space',
    component: StudentLearningSpace,
    icon: 'ed-student-learning-space',
    permission: 'student_learning_space',
  },
  {
    id: 'timetable',
    title: 'Timetable',
    route: 'timetable',
    component: Timetable,
    icon: 'ed-timetable',
    permission: 'timetable',
  },
];
